import React, { useRef, useState } from "react";
import ImageWithBasePath from "core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import {
  useResetPasswordMutation,
  useVerifyEmailMutation,
  useVerifyOTPMutation,
} from "AppQuries/login/forgot-password";
import { toast } from "core/Operations/toast";
import ResetPassword from "./ResetPassword";

const ForgotPassword = () => {
  const emailRef = useRef();
  const otpRef = useRef();
  const [resentOTP, setResentOTP] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState();
  const [emailVeificationMsg, setEmailVeificationMsg] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [userDetails, setUserDetails] = useState(null);

  const { mutate: verifyEmail, isPending: isEmailVerifying } =
    useVerifyEmailMutation();
  const { mutate: verifyOTP } = useVerifyOTPMutation();
  const { mutate: resetPasswordMutate } = useResetPasswordMutation();

  const verifyEmailHandler = () => {
    console.log(emailRef.current.value);
    const email = emailRef.current.value;
    console.log(email);
    if (email !== "" && email.includes("@")) {
      verifyEmail(
        { email: email },
        {
          onSuccess: (data) => {
            if (data?.response === true) {
              setIsValidEmail(true);
              setResentOTP(!resentOTP);
            } else {
              setIsValidEmail(false);
            }
            setEmailVeificationMsg(
              data?.errorMessage || "Something went wrong."
            );
          },
        }
      );
    } else {
      setIsValidEmail(false);
      setEmailVeificationMsg("Enter valid email address");
    }
  };

  const navigate = useNavigate();

  const verifyOTPHandler = () => {
    const otpValue = otpRef.current.value;
    console.log(otpValue);
    if (otpValue !== "") {
      verifyOTP(
        { otp: otpValue, email: emailRef.current.value },
        {
          onSuccess: (data) => {
            if (data?.response === true) {
              setIsOtpVerified(true);
              setUserDetails(data?.userLogin || []);
            } else {
              toast.warning(data?.errorMessage || "Something went wrong.");
            }
          },
        }
      );
    } else {
      toast.warning("Enter valid OTP");
    }
  };
  const route = all_routes;
  // OTP timer state
  const [otpTimer, setOtpTimer] = useState(45);
  const [canResendOtp, setCanResendOtp] = useState(false);

  // Start timer when OTP is sent (when isValidEmail becomes true)
  React.useEffect(() => {
    let timer;
    if (isValidEmail) {
      setOtpTimer(45);
      setCanResendOtp(false);
      timer = setInterval(() => {
        setOtpTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setCanResendOtp(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isValidEmail, resentOTP]);

  // Dummy resend OTP handler
  const resendOTPHandler = () => {
    setCanResendOtp(false);
    setOtpTimer(45);
    verifyEmailHandler();

    toast.success("OTP resent!");
  };

  return isValidEmail && isOtpVerified ? (
    <ResetPassword
      userDetails={userDetails}
      // resetPasswordHandler={resetPasswordHandler}
    />
  ) : (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper login-new">
          <div className="container">
            <div className="login-content user-login">
              <div className="login-logo">
                <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                <Link to="#" className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt />
                </Link>
              </div>

              <div className="login-userset">
                <form className="needs-validation digit-group">
                  <div className="login-userheading">
                    <h3>Forgot password?</h3>
                    <h4>
                      If you forgot your password, well, then we’ll email you
                      instructions to reset your password.
                    </h4>
                  </div>
                  <div className="form-login">
                    <label>Email</label>
                    <div className="form-addons">
                      <input
                        type="email"
                        className={`form-control ${
                          isValidEmail === true
                            ? "is-valid"
                            : isValidEmail === false
                            ? "is-invalid"
                            : ""
                        }`}
                        readOnly={isValidEmail}
                        ref={emailRef}
                      />
                      <ImageWithBasePath
                        src="assets/img/icons/mail.svg"
                        alt="img"
                      />
                      {isValidEmail === true ? (
                        <div className="valid-feedback">
                          {emailVeificationMsg}
                        </div>
                      ) : isValidEmail === false ? (
                        <div className="invalid-feedback">
                          {emailVeificationMsg}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  {isValidEmail && (
                    <>
                      <div className="wallet-add">
                        <div className="otp-title">
                          <h4>Enter the OTP sent to your email</h4>
                        </div>
                        <div className="inputs d-flex flex-wrap">
                          <input
                            type="text"
                            className="form-control"
                            ref={otpRef}
                          />
                        </div>
                      </div>
                      <div className="text-center resend mt-3">
                        <p>
                          Resend Otp in
                          {otpTimer > 0
                            ? `00:${otpTimer.toString().padStart(2, "0")}`
                            : "00:00"}
                        </p>
                        <button
                          onClick={resendOTPHandler}
                          className="btn btn-link"
                          type="button"
                          disabled={!canResendOtp}
                        >
                          Resend Otp
                        </button>
                      </div>
                    </>
                  )}

                  <div className="form-login">
                    {isValidEmail === true ? (
                      <Link
                        onClick={verifyOTPHandler}
                        className="btn btn-login"
                      >
                        Verify OTP
                      </Link>
                    ) : (
                      <button
                        onClick={verifyEmailHandler}
                        className="btn btn-login"
                        type="button"
                        disabled={isEmailVerifying}
                      >
                        {isEmailVerifying ? (
                          <>
                            <i className="fas fa-spinner fa-spin me-2"></i>
                            Verifying...
                          </>
                        ) : (
                          <>Verify Email & Send OTP</>
                        )}
                      </button>
                    )}
                  </div>
                  <div className="signinform text-center">
                    <h4>
                      Return to
                      <Link to={route.login} className="hover-a">
                        
                        login
                      </Link>
                    </h4>
                  </div>
                </form>
              </div>
            </div>
            <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
              <p>Copyright © 2024 WINHRMS. All rights reserved</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
